import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'
//创建axios实例
let request = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})
//请求拦截器
request.interceptors.request.use((config) => {
  if (store.getters.getRole) {
    config.headers.currentRole = store.getters.getRole
  }
  if (localStorage.getItem('token')) {
    config.headers.Authorization = localStorage.getItem('token')
  }
  return config
})
//响应拦截器
request.interceptors.response.use(
  (response) => {
    if (response.data.code === 401) {
      Message.error('登录过期，请重新登录')
      store.dispatch('clearToken')
      store.dispatch('deleteUser')
      router.push('/login')
    } else if (response.data.code === 0) {
      Message.error(response.data.data)
    } else {
      return response.data
    }
  },
  (error) => {
    //处理网络错误
    let msg = ''
    let status = error.response.status
    switch (status) {
      case 401:
        msg = 'token过期'
        store.dispatch('clearToken')
        store.dispatch('deleteUser')
        router.push('/login')
        break
      case 403:
        msg = '无权访问'
        break
      case 404:
        msg = '请求地址错误'
        break
      case 500:
        msg = '服务器出现问题'
        break
      default:
        msg = '无网络'
    }
    if (status !== 401) {
      Message({
        type: 'error',
        message: msg
      })
    }
    return Promise.reject(error)
  }
)
export default request
